import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { NavigationTab, NavigationProps, TAB_CONFIGS } from '../types/navigation';

export const BottomNavigationWeb: React.FC<NavigationProps> = ({ 
  activeTab, 
  onTabChange 
}) => {
  const tabs: NavigationTab[] = [
    'ChildNav',
    'Milestones', 
    'Concerns',
    'Well-Visit',
    'Guidance',
    'Actions'
  ];

  return (
    <View style={styles.container}>
      {tabs.map((tab) => {
        const config = TAB_CONFIGS[tab];
        const isActive = activeTab === tab;
        
        return (
          <TouchableOpacity
            key={tab}
            style={{...styles.tab, ...(isActive ? styles.activeTab : {})}}
            onPress={() => onTabChange(tab)}
          >
            <Text style={{...styles.icon, ...(isActive ? styles.activeIcon : {})}}>
              {config.icon}
            </Text>
            <Text style={{...styles.label, ...(isActive ? styles.activeLabel : {})}}>
              {config.label}
            </Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    backgroundColor: '#ffffff',
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 4,
    paddingRight: 4,
    borderTopWidth: 1,
    borderTopColor: '#e1e8ed',
  },
  tab: {
    flex: 1,
    alignItems: 'center',
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 4,
    paddingRight: 4,
    borderRadius: 8,
    marginLeft: 2,
    marginRight: 2,
  },
  activeTab: {
    backgroundColor: '#f0f8ff',
  },
  icon: {
    fontSize: 20,
    marginBottom: 2,
  },
  activeIcon: {
    transform: [{ scale: 1.1 }],
  },
  label: {
    fontSize: 10,
    color: '#7f8c8d',
    textAlign: 'center',
    fontWeight: '500',
  },
  activeLabel: {
    color: '#3498db',
    fontWeight: '600',
  },
});